import { render, staticRenderFns } from "./AuthorTrue.vue?vue&type=template&id=4e08c6f6&scoped=true"
import script from "./AuthorTrue.vue?vue&type=script&lang=js"
export * from "./AuthorTrue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e08c6f6",
  null
  
)

export default component.exports